/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_business_api_keys_table_status_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Pendiente`
};

const en_developer_business_api_keys_table_status_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Pending`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_business_api_keys_table_status_pending = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_business_api_keys_table_status_pending(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_business_api_keys_table_status_pending", locale)
	if (locale === "es") return es_developer_business_api_keys_table_status_pending(inputs)
	return en_developer_business_api_keys_table_status_pending(inputs)
};
export { developer_business_api_keys_table_status_pending as "developer.business_api_keys.table.status_pending" }